import React from 'react';
import './Home.css';
import FeaturedInfo from '../../components/FeaturedInfo/FeaturedInfo'
import Chart from '../../components/Chart/Chart';
import PieChart1 from '../../components/PieChart1/PieChart1';
import PieChart2 from '../../components/PieChart2/PieChart2';
import User from '../User/User';

function Home() {
  return (
    <div className='home'>
        <FeaturedInfo/>
        <Chart/>
        <div style={{display:'flex'}}>
          <PieChart1/>
          <PieChart2/>
        </div>

         
    </div>
  )
}

export default Home;